const validateCustomTrackingData = (trackingData = {}) => {
  if (!trackingData.page) {
    throw new Error('page is mandatory')
  }
}

export { validateCustomTrackingData }
